import Bills from "../components/CheckOut/Bills";
import CheckOut from "../components/CheckOut/CheckOut";
import CheckOutSuccess from "../components/CheckOut/Success";

export const checkOutRoutes = (prefix = "") => {
	return [
		{
			path: prefix,
			exact: true,
			section: CheckOut
		},
		{
            path: prefix + "/bills",
            exact: true,
            section: Bills,
        },
		{
            path: prefix + "/success",
            exact: true,
            section: CheckOutSuccess,
        },
	];
};
